import React from 'react';
import PropTypes from 'prop-types';
import './Group.scss';

const Group = props => {
  const width = props.desktopUp ? props.desktopWidth : '100%';
  const gutter = props.desktopUp ? props.desktopGutter : '30px';
  const intGutter = parseInt(gutter.replace('px', ''), 10);
  const columnMargin = `${intGutter / 2}px`;

  return (
    <section className="grid__group">
      <div className="container-guttered">
        <div
          className="grid__column-wrapper"
          style={{
            margin: props.desktopUp && `0 -${columnMargin}`,
            width: props.desktopUp && `calc(${width} + ${gutter})`,
            flexDirection: props.desktopUp && props.desktopAlignment,
          }}>
          {props.items.map(ErrorBoundary => {
            // Because props.items is actually an array of ErrorBoundary components
            // and their children is the actual slice. I needed to use .cloneElement
            // to pass props down to the Column component as well as render the component.
            return (
              React.cloneElement(
                ErrorBoundary.props.children, {
                  desktopMargin: props.desktopUp && columnMargin,
                  desktopUp: props.desktopUp
                }
              )
            );
          })}
        </div>
      </div>
    </section>
  );
};

Group.propTypes = {
  desktopWidth: PropTypes.string.isRequired,
  desktopGutter: PropTypes.string.isRequired,
  desktopAlignment: PropTypes.string.isRequired,
  desktopUp: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(PropTypes.node.isRequired).isRequired
};

export default Group;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Group/Group.js